
import React from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import {Collapse} from "antd";
import MagazineColData from "../Data/MagazineColData"
import MagazineImagesData from "../Data/MagazineImagesData";

const MagazinStyle = () => {

  return (
    <section className="aa-ph-container py-[70px] sm:py-[100px] px-4 sm:px-2 lg:px-0">
      <h2 className="text-center font-medium text-[32px] sm:text-[60px] md:text-[90px] lg:text-[130px] leading-[38px] sm:leading-[70px] md:leading-[100px] lg:leading-[160px]">
      HAPPY MEMORIES
      </h2>
      <div className="w-[90%] mx-auto grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-16">
        { MagazineImagesData?.map((image, ind) => (
            <img key={ind} src={image?.imgSrc} alt="photo-booth-magazine" className="w-full h-auto" /> 
        ))}
        
      </div>
      <div className="mx-auto w-full sm:max-w-[1200px] pt-[50px] flex flex-col sm:flex-row gap-6 sm:gap-0 items-start">
        <div className="w-full sm:w-1/2 pr-0 sm:pr-[80px]">
          <h4 className="text-[18px] sm:text-[24px] leading-[24px] sm:leading-[32px] font-poppins-regular">
          Our 360 photo booth takes up to 5 guests as its studio grade camera rotates around them creating an impactful variable speed style video, showcasing their look, energy, fashion, and more.
          </h4>
          <button className="mt-8 uppercase font-poppins-regular text-[#fff] text-[14px] sm:text-[16px] bg-[#000] px-[14px] sm:px-[32px] py-[8px] sm:py-[16px] rounded-[40px] ">
          BOOK TO CAPTURE
          </button>
        </div>
        <div className="w-full sm:w-1/2">
          <Collapse
            bordered={false}
            expandIcon={({ isActive }) => ( <> { isActive ? <MinusOutlined /> : <PlusOutlined /> } </>)}
            expandIconPosition="end"
            items={MagazineColData}
          />
        </div>
      </div>
    </section>
  );
};

export default MagazinStyle;


